import { useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';
import { Megaphone, Send } from 'lucide-react';

export default function AdminBroadcasts() {
  const [f, setF] = useState({ title: '', body: '', target: 'all' });
  const [loading, setLoading] = useState(false);

  const send = async () => {
    setLoading(true);
    try {
      const r = await api.post('/broadcasts', f);
      toast.success(`Sent to ${r.data.sent_count} clients`);
      setF({ title: '', body: '', target: 'all' });
    } catch { toast.error('Failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-6" data-testid="admin-broadcasts">
      <div>
        <div className="label-mini text-[#FFB800]">Mass Comms</div>
        <h1 className="font-display font-black text-4xl mt-1">Broadcasts</h1>
      </div>
      <div className="regen-card-elevated p-6 max-w-2xl space-y-4">
        <div className="flex items-center gap-2"><Megaphone className="w-5 h-5 text-[#FFB800]" /><div className="font-display font-bold">New Broadcast</div></div>
        <div><Label>Title</Label><Input value={f.title} onChange={e => setF({...f, title: e.target.value})} data-testid="bc-title" className="bg-regen-card border-[var(--c-hair)]" /></div>
        <div><Label>Message</Label><Textarea value={f.body} onChange={e => setF({...f, body: e.target.value})} rows={5} data-testid="bc-body" className="bg-regen-card border-[var(--c-hair)]" /></div>
        <div><Label>Target</Label>
          <Select value={f.target} onValueChange={v => setF({...f, target: v})}>
            <SelectTrigger data-testid="bc-target" className="bg-regen-card border-[var(--c-hair)]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Clients</SelectItem>
              <SelectItem value="plan:YOURREGEN6">YourReGen 6 only</SelectItem>
              <SelectItem value="plan:YOURREGEN12">YourReGen 12 only</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button onClick={send} disabled={loading || !f.title || !f.body} data-testid="bc-send" className="bg-[#FFB800] text-[#081726] font-semibold w-full">
          <Send className="w-4 h-4 mr-2" /> {loading ? 'Sending…' : 'Send Broadcast'}
        </Button>
      </div>
    </div>
  );
}
